export default __webpack_public_path__ + "98cb84f6f38214dc09c3d5c2a85a5f73.png";